import { Horizon } from '@stellar/stellar-sdk';
import { useMemo } from 'react';

import * as actions from './actions';
import { AuthStore, LoginArgs, LoginTypes } from './types';

import bindActions from '../bindActions';
import { useAuthState, useStoreDispatch } from '../index';
import { ActionAsyncResult, ActionSimpleResult } from '../types';

type AuthActions = {
    setSessionRestorePending: (pending: boolean) => ActionSimpleResult;
    login: (args: LoginArgs) => ActionAsyncResult;
    logout: () => ActionSimpleResult;
    resolveFederation: (homeDomain: string, accountId: string) => ActionAsyncResult;
    updateAccount: (
        account: Horizon.AccountResponse | Horizon.ServerApi.AccountRecord,
        authType: LoginTypes,
    ) => ActionSimpleResult;
    clearLoginError: () => ActionSimpleResult;
    enableRedirect: (redirectURL: string) => ActionSimpleResult;
    disableRedirect: () => ActionSimpleResult;
    addAuthCallback: (cb: () => void) => ActionSimpleResult;
    removeAuthCallback: () => ActionSimpleResult;
};

// TODO: move to hooks
const useAuthStore = (): AuthStore & AuthActions => {
    const authStore = useAuthState();
    const dispatch = useStoreDispatch();

    // List Actions
    const {
        setSessionRestorePending,
        login,
        logout,
        resolveFederation,
        updateAccount,
        clearLoginError,
        enableRedirect,
        disableRedirect,
        addAuthCallback,
        removeAuthCallback,
    } = actions;

    const authActions = useMemo(
        () =>
            bindActions(
                {
                    setSessionRestorePending,
                    login,
                    logout,
                    resolveFederation,
                    updateAccount,
                    clearLoginError,
                    enableRedirect,
                    disableRedirect,
                    addAuthCallback,
                    removeAuthCallback,
                },
                dispatch,
            ) as unknown as AuthActions,
        [dispatch],
    );

    return { ...authStore, ...authActions };
};

export default useAuthStore;
